module.exports = {"361129100":"陈营镇","361129101":"石镇镇","361129102":"青云镇","361129103":"梓埠镇","361129104":"大源镇","361129105":"裴梅镇","361129200":"湖云乡","361129201":"齐埠乡","361129203":"汪家乡","361129205":"上坊乡","361129206":"苏桥乡","361129208":"珠田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361129.json
// module id = 1247
// module chunks = 0